import React, { useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  $isTextNode,
  FORMAT_TEXT_COMMAND,
} from 'lexical';

import { getSelectedNode } from '../../utils';
import FormatLink from './FormatLink';
import {
  INSERT_CODE_HIGHLIGHT_COMMAND,
  $isCodeHighLightNode,
} from '../CodeHighlightPlugin';
import { useSetting } from 'src/components/custom/Editor/hooks';

type Props = {
  link?: boolean;
};

const FormatTextStyle: React.FC<Props> = ({ link }) => {
  const [editor] = useLexicalComposerContext();
  const [isBold, setIsBold] = useState<boolean>(false);
  const [isItalic, setIsItalic] = useState<boolean>(false);
  const [isUnderline, setIsUnderline] = useState<boolean>(false);
  const [isStrikethrough, setIsStrikethrough] = useState<boolean>(false);
  const [isCode, setIsCode] = useState<boolean>(false);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return;

        const node = getSelectedNode(selection);

        if ($isTextNode(node)) {
          setIsBold(node.hasFormat('bold'));
          setIsItalic(node.hasFormat('italic'));
          setIsUnderline(node.hasFormat('underline'));
          setIsStrikethrough(node.hasFormat('strikethrough'));
          setIsCode($isCodeHighLightNode(node));
        }
      });
    });
  }, [editor]);

  const { editable } = useSetting();

  return (
    <React.Fragment>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
        }}
        className={'toolbar-item spaced ' + (isBold ? 'active' : '')}
        aria-label="Format Bold"
        disabled={!editable}
      >
        <i className="format bold" />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
        }}
        className={'toolbar-item spaced ' + (isItalic ? 'active' : '')}
        aria-label="Format Italics"
        disabled={!editable}
      >
        <i className="format italic" />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
        }}
        className={'toolbar-item spaced ' + (isUnderline ? 'active' : '')}
        aria-label="Format Underline"
        disabled={!editable}
      >
        <i className="format underline" />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough');
        }}
        className={'toolbar-item spaced ' + (isStrikethrough ? 'active' : '')}
        aria-label="Format Strikethrough"
        disabled={!editable}
      >
        <i className="format strikethrough" />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(INSERT_CODE_HIGHLIGHT_COMMAND, isCode);
        }}
        className={'toolbar-item spaced ' + (isCode ? 'active' : '')}
        aria-label="Format Strikethrough"
        disabled={!editable}
      >
        <i className="format code" />
      </button>
      <FormatLink link={link} />
    </React.Fragment>
  );
};

export default FormatTextStyle;
